module.exports = __webpack_public_path__ + "static/media/print-passcodes.a4c1daa2.png";